<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JS5l1H/tc-custom/9781504000895.jpg?1705806767235" alt="This image is the cover for the book Beat the Turtle Drum"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beat the Turtle Drum
      </h1>
      <p class="bookDescription body article font2">
        <b>An ALA Notable Book and an IRA-CBC Children’s Choice: Losing your sister can mean losing your best friend too</b><br/><br/> Thirteen-year-old Kate is thrilled for her sister, Joss, when Joss finds out she gets to keep a horse for a week as a birthday present.<br/><br/> Then in one tragic moment, all of the happiness is gone, and numbness and grief overwhelm the family. Kate cannot imagine how she’ll survive but knows somehow she must come to terms with her loss. In this heart-wrenching story, Kate strives to find a place where joyful memories and painful loss can coexist.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Constance C. Greene
      </h2>
      
      <p class="authorDescription body article">Constance C. Greene was the author of over twenty highly successful children&rsquo;s and young adult novels, including the ALA Notable Book <I>A Girl Called Al</I>, <I>Al(exandra) the Great</I>, <I>Getting Nowhere</I>, and <I>Beat the Turtle Drum</I>, which is an ALA Notable Book, an IRA-CBC Children&rsquo;s Choice, and the basis for the Emmy Award&ndash;winning after-school special <I>Very Good Friends</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d695428e